export default class StandardSection {

  constructor(section = {}) {
    this.id = section.id || null
    this.title = section.title || ''
    this.description = section.description || ''
    this.checkpoints = section.checkpoints || []
  }

  mutations() {
    return {
      setSection: (state, section) => state.section = new StandardSection(section),
      clearSection: (state) => state.section = new StandardSection(),
      updateTitle: (state, title) => state.section.title = title,
      updateDescription: (state, description) => state.section.description = description
    }
  }

}